/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * User-defined display name for a hooks server
 */
export type ServerNameOverride = {
  /**
   * User-friendly display name
   */
  displayName: string;
  /**
   * Override ID
   */
  id: string;
  /**
   * Original server name from hooks
   */
  rawServerName: string;
};

/** @internal */
export const ServerNameOverride$inboundSchema: z.ZodMiniType<
  ServerNameOverride,
  unknown
> = z.pipe(
  z.object({
    display_name: z.string(),
    id: z.string(),
    raw_server_name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "display_name": "displayName",
      "raw_server_name": "rawServerName",
    });
  }),
);

export function serverNameOverrideFromJSON(
  jsonString: string,
): SafeParseResult<ServerNameOverride, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ServerNameOverride$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ServerNameOverride' from JSON`,
  );
}
